import { render, staticRenderFns } from "./ParametrizacaoTemplateProposta.vue?vue&type=template&id=c2f09c0e"
import script from "./ParametrizacaoTemplateProposta.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoTemplateProposta.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoTemplateProposta.vue?vue&type=style&index=0&id=c2f09c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports